export const theme = {
  colors: {
    primary: '#600081',    // Embassy of Life Purple
    secondary: '#E5B45B',  // Embassy of Life Gold
    primaryDark: '#4A0066', // Darker purple for hover states
    text: {
      primary: '#333333',  // Almost black for main text
      secondary: '#666666', // Dark gray for secondary text
      light: '#FFFFFF'     // White text
    },
    background: {
      light: '#FFFFFF',    // White background
      dark: '#000000',     // Almost black background
      purple: '#730099',   // Pure purple background
      gray: '#f8f8f8'      // Pure gold background
    },
    white: '#FFFFFF',
    border: '#E5E7EB'
  },
  fonts: {
    primary: "'Space Grotesk', sans-serif",
    secondary: "'Inter', sans-serif"
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '968px',
    large: '1200px'
  },
  transitions: {
    default: 'all 0.3s ease',
    slow: 'all 0.6s ease',
    fast: 'all 0.2s ease'
  },
  shadows: {
    small: '0 2px 8px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 12px rgba(0, 0, 0, 0.1)',
    large: '0 8px 24px rgba(0, 0, 0, 0.15)',
    purple: '0 4px 15px rgba(96, 0, 129, 0.2)'
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '2rem',
    xl: '4rem'
  }
};

export const lightTheme = {
  primary: '#007bff',
  secondary: '#6c757d',
  background: '#ffffff',
  text: '#333333',
  surface: '#f8f9fa',
  border: '#dee2e6',
  error: '#dc3545',
  success: '#28a745',
  warning: '#ffc107',
  info: '#17a2b8',
};

export const darkTheme = {
  primary: '#0d6efd',
  secondary: '#6c757d',
  background: '#121212',
  text: '#ffffff',
  surface: '#1e1e1e',
  border: '#2d2d2d',
  error: '#dc3545',
  success: '#28a745',
  warning: '#ffc107',
  info: '#17a2b8',
};

export default theme; 